import React, { useContext } from 'react';
import { useMAppAuth } from "../../hooks/useMAppAuth";

type TUserContext = {
  isLoading: boolean;
  logout: () => void;
  user: Record<string, string>;
}
export const UserContext = React.createContext<TUserContext>({
  isLoading: false,
  logout: () => {},
  user: {}
});

export function UserContextProvider({ children }: { children: JSX.Element }): JSX.Element {
  const { isLoading, user, logout } = useMAppAuth();

  return (
    <UserContext.Provider value={{ isLoading, user, logout }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUserContext = () => useContext(UserContext)
